import { Typography } from '@mui/material';
import { Link, RouteComponentProps } from '@reach/router';
import { PolicyStreamPageContainer } from './components/PageContainer';
import Button from '@mui/material/Button';
import { styled } from '@mui/material';
import { useEffect } from 'react';
import { usePolicyStreamGoogleAnalytics } from '../../hooks/usePolicyStreamGoogleAnalytics';
import {
  GAEventNames,
  EventActions,
} from '../../hooks/usePolicyStreamGoogleAnalytics/types';
// import { useEnsureFormPresent } from '../../hooks/useEnsureFormPresent';
// import { POLICYSTREAM_FORMS } from './constants';
import { policyStreamPaths } from './policyStreamConstants';
import { useSetPolicyStreamSaveButtonVisibility } from '../../hooks';
import { PolicyStreamLayout } from './components';
import { useEnsureFormPresent } from '../../hooks/useEnsureFormPresent';
import { POLICYSTREAM_FORMS } from './constants';
import { PolicyStreamSendResumeEmailButton } from './components';
import { PolicyStreamContentCard } from './PolicyStreamContentCard';
import { ArrowOutward } from '@mui/icons-material';
import { useSettings } from '../../hooks/useSettings/useSettings';
import { useUsingBroudieInsurance } from './hooks/useUsingOrganizationHooks';

const DEFAULT_POLICYSTREAM_INTRODUCTORY_TEXT =
  'Explore our plans directly, or take our quick 5-minute quiz to get a personalized recommendation tailored to you—including the perfect product, term length, and coverage amount.';

export const PolicyStreamWelcomePage = (_props: RouteComponentProps) => {
  const { settings } = useSettings();
  const myAnalytics = usePolicyStreamGoogleAnalytics();
  const customIntroductoryText = settings.policystreamIntroductoryText.trim();
  const onBroudieInsurance = useUsingBroudieInsurance();

  useSetPolicyStreamSaveButtonVisibility(false);
  // to make loading the next page faster
  useEnsureFormPresent({ internalName: POLICYSTREAM_FORMS.basicInfo });

  // Send Google Analytics event on component load
  useEffect(() => {
    myAnalytics?.triggerEvent(
      GAEventNames.Welcome,
      EventActions.PageLoad,
      'PolicyStream Welcome Page',
    );
  }, [myAnalytics]);
  // const recommendation = useEnsureFormPresent({
  //   internalName: POLICYSTREAM_FORMS.needsAnalysis,
  // });
  return (
    <PolicyStreamLayout>
      <PolicyStreamPageContainer>
        <Typography variant='h2' fontWeight={500}>
          Welcome!
        </Typography>
        {onBroudieInsurance ? null : (
          <WelcomePlanIntroText variant='h6'>
            Let's get you a plan, but first we need to know a little bit about
            you.
          </WelcomePlanIntroText>
        )}

        {customIntroductoryText.length > 0 ? (
          <CustomIntroductoryText variant='body1'>
            {customIntroductoryText}
          </CustomIntroductoryText>
        ) : null}

        <PolicyStreamContentCard>
          {DEFAULT_POLICYSTREAM_INTRODUCTORY_TEXT}
          <ActionButtonsContainer>
            <Button
              component={Link}
              to={policyStreamPaths.baseInformation.slug}
              variant='contained'
              size='large'
              sx={{
                borderRadius: (theme) => theme.spacing(2),
                minWidth: '250px',
              }}
            >
              Let's get started
              <ArrowOutward />
            </Button>
          </ActionButtonsContainer>
        </PolicyStreamContentCard>
        <Typography
          variant='h6'
          fontWeight={600}
          marginTop={(theme) => theme.spacing(2)}
          marginBottom={(theme) => theme.spacing(2)}
        >
          Already Started?
        </Typography>

        <PolicyStreamContentCard>
          Do you already have an application in progress? Great! Click below and
          we'll send you a link to continue where you left off.
          <PolicyStreamSendResumeEmailButton>
            Click to Continue
            <ArrowOutward />
          </PolicyStreamSendResumeEmailButton>
        </PolicyStreamContentCard>
      </PolicyStreamPageContainer>
    </PolicyStreamLayout>
  );
};

const WelcomePlanIntroText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const CustomIntroductoryText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const ActionButtonsContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});
